import { render, staticRenderFns } from "./InspectionFrequencyComponent.vue?vue&type=template&id=402b0fe8&scoped=true"
import script from "./InspectionFrequencyComponent.vue?vue&type=script&lang=js"
export * from "./InspectionFrequencyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b0fe8",
  null
  
)

export default component.exports